
import axios from 'axios';

import {
  defineComponent,
  ref,
  onMounted,
  computed,
} from 'vue';

import {
  AdSecureAnalyzes,
  EntriesPaginator,
  Projects,
} from '@/types';

import {
  ENTRIES,
  ADSECURE_ANALYSIS_STATUSES_MAP,
} from '@/libs/consts';

import useUser from '@/composable/useUser';

import useEntriesNext from '@/composable/useEntries@next';

import useUrlState from '@/composable/useUrlState';

export default defineComponent({
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    showRelationsColumns: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { activeUser: user } = useUser();

    const {
      entries: projects,
      entriesLoading: projectsLoading,
      fetchEntries: fetchProjects,
    } = useEntriesNext<Projects>('/api/project/getProjects', ENTRIES);

    const adSecureAnalyzes = ref<AdSecureAnalyzes>(ENTRIES);

    const adSecureAnalyzesFilters = useUrlState('filters', {
      project_id: null,
      user_id: null,
      campaign_id: null,
      feed_id: null,
      url: null,
    });

    const usersParams = computed(() => ({
      include: 'project',
      'filter[project_id]': user.isSuperAdmin() ? adSecureAnalyzesFilters.project_id : undefined,
    }));

    const campaignsParams = computed(() => ({
      include: 'project,user',
      'filter[project_id]': user.isSuperAdmin() ? adSecureAnalyzesFilters.project_id : undefined,
      'filter[user_id]': adSecureAnalyzesFilters.user_id,
    }));

    const feedsParams = computed(() => ({
      include: 'project',
      'filter[project_id]': user.isSuperAdmin() ? adSecureAnalyzesFilters.project_id : undefined,
    }));

    const fetchAdSecureAnalyzes = async (adSecureAnalyzesPaginator: EntriesPaginator): Promise<void> => {
      const response = await axios.post(
        'api/adsecure/getAnalyzesPaginator',
        {
          ...adSecureAnalyzesPaginator,
          ...adSecureAnalyzesFilters,
          ...props.filters,
        },
      );

      adSecureAnalyzes.value = response.data;
    };

    const onProjectChange = (): void => {
      adSecureAnalyzesFilters.user_id = null;

      adSecureAnalyzesFilters.feed_id = null;

      adSecureAnalyzesFilters.campaign_id = null;
    };

    const onUserChange = (): void => {
      adSecureAnalyzesFilters.campaign_id = null;
    };

    if (props.showRelationsColumns) {
      onMounted(async (): Promise<void> => {
        if (user.isSuperAdmin()) {
          await fetchProjects();
        }
      });
    }

    return {
      ADSECURE_ANALYSIS_STATUSES_MAP,
      user,
      adSecureAnalyzes,
      adSecureAnalyzesFilters,
      usersParams,
      campaignsParams,
      feedsParams,
      projects,
      projectsLoading,
      fetchAdSecureAnalyzes,
      onProjectChange,
      onUserChange,
    };
  },
});
